<template>
  <div>
    <v-card-text class="d-none d-md-block">
      <MemoryDataTable
        :columns="colunas"
        :items="getProdutosPedido"
        itemKey="id"
        :items-per-page="5"
        :showPagination="true"
        :objetoPaginacao="{
          itemsPerPage: 10,
          showFirstLastPage: true
        }"
      >
        <template v-slot:[`item.imagem`]="{ item }">
          <v-img
            v-bind="{ ...buildProdutoImage(item.produto) }"
            max-width="100px"
            max-height="100px"
            contain
          />
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                link
                class="px-4"
                @click="onEditarProdutoClick(item)"
              >
                <v-icon class="mr-2">mdi-eye</v-icon>Visualizar
              </v-list-item>
              <v-list-item
                link
                class="px-4"
                @click="onExcluirProdutoClick(item)"
              >
                <v-icon class="mr-2">mdi-trash-can-outline</v-icon>Excluir
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:[`item.valorUnit`]="{ item }">
          <div class="d-flex flex-column">
            <span
              class="font-weight-regular text-caption grey--text text-decoration-line-through"
              v-if="getValorTotalDesconto(item) > 0"
            >
              {{ moneyFormatter(getPrecoPadrao(item)) }}
            </span>

            <span class="font-weight-regular">
              {{ moneyFormatter(item.valorUnit, true) }}
              <!-- icone de desconto -->
              <v-tooltip right v-if="getValorTotalDesconto(item) > 0">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="theme--light"
                    size="medium"
                    color="success"
                    v-if="item.produto?.promocao"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-sale
                  </v-icon>
                </template>
                <span
                  >Desconto de
                  {{ moneyFormatter(getValorTotalDesconto(item)) }}</span
                >
              </v-tooltip>

              <!-- Novo: ícone para cupom -->
              <v-tooltip right v-if="getCupomAplicado(item)">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="theme--light ml-1"
                    size="medium"
                    color="info"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-ticket-percent
                  </v-icon>
                </template>
                <span
                  >Cupom aplicado:
                  {{ getCupomAplicado(item)?.cupom_code }}</span
                >
              </v-tooltip>
            </span>
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <span class="font-weight-bold">
            {{ moneyFormatter(item.valorUnit * item.quantidade) }}</span
          >
        </template>
      </MemoryDataTable>
    </v-card-text>

    <v-card-text class="ma-0 pa-0 d-md-none">
      <v-list>
        <template v-for="(item, index) in getProdutosPedido">
          <v-list-item :key="item.id" class="ma-0 pa-0 mb-4">
            <v-list-item-avatar size="80">
              <v-img v-bind="{ ...buildProdutoImage(item.produto) }" contain />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ item.produto.descricao_portal }}
              </v-list-item-title>

              <v-list-item-subtitle class="mt-2">
                <div class="d-flex align-center">
                  <span
                    >Qtde: {{ item.quantidade }} {{ item.unidadeMedida }}</span
                  >
                </div>

                <div class="d-flex align-center mt-1">
                  <span
                    class="text-decoration-line-through grey--text mr-2"
                    v-if="getValorTotalDesconto(item) > 0"
                  >
                    {{ moneyFormatter(getPrecoPadrao(item)) }}
                  </span>
                  <span class="primary--text font-weight-medium">{{
                    moneyFormatter(item.valorUnit)
                  }}</span>
                  <v-icon
                    color="success"
                    small
                    class="ml-1"
                    v-if="getValorTotalDesconto(item) > 0"
                    >mdi-sale</v-icon
                  >
                </div>

                <div class="mt-1 font-weight-bold">
                  Total: {{ moneyFormatter(item.valorUnit * item.quantidade) }}
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action class="align-self-start mt-2">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="onEditarProdutoClick(item)">
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-eye</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Visualizar</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="onExcluirProdutoClick(item)">
                    <v-list-item-icon class="mr-2">
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-action>
          </v-list-item>

          <v-divider
            v-if="index < getProdutosPedido.length - 1"
            :key="`divider-${item.id}`"
            class="mb-4"
          ></v-divider>
        </template>
      </v-list>
    </v-card-text>

    <v-card-actions
      class="d-flex flex-column flex-md-row justify-space-between mx-0 mx-md-2"
    >
      <v-btn
        class="mx-2 my-2"
        color="error"
        outlined
        @click="onLimparCarrinhoClick"
        height="45px"
        :block="$vuetify.breakpoint.smAndDown"
      >
        <v-icon class="mx-2">mdi-trash-can-outline</v-icon> Limpar Carrinho
      </v-btn>

      <v-btn
        class="mx-2 my-2"
        color="primary"
        outlined
        @click="onContinuarComprandoClick"
        height="45px"
        :block="$vuetify.breakpoint.smAndDown"
      >
        <v-icon class="mx-2">mdi-arrow-left</v-icon> Continuar comprando
      </v-btn>
    </v-card-actions>

    <ProdutoDetailsDialog ref="dlgProdDet" />
    <LoaderContainer :value="isLoading" />
    <QuestionDialog @aprovarClick="handleRemoveProduto" ref="dlgQuestion" />
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { moneyFormatter } from '../utils'
import ProdutoDetailsDialog from '@/components/produtos/ProdutoDetailsDialog.vue'
import LoaderContainer from '@/components/Loader.vue'
import ProdutosService, {
  calcular_preco_unidade_medida
} from '@/services/ProdutosService'
import QuestionDialog from '@/components/dialogs/QuestionDialog.vue'
import MemoryDataTable from '@/components/wmc/MemoryDataTable.vue'
import imageService from '@/services/ImageService'

export default {
  name: 'CheckoutProdutosContainer',

  components: {
    ProdutoDetailsDialog,
    LoaderContainer,
    QuestionDialog,
    MemoryDataTable
  },

  data () {
    return {
      isLoading: false,
      colunas: [
        {
          text: '',
          align: 'center',
          value: 'imagem',
          width: '1em'
        },
        {
          text: 'Cod.',
          align: 'start',
          value: 'produto.id',
          width: '5em'
        },
        {
          text: 'Produto',
          align: 'start',
          value: 'produto.descricao_portal',
          width: '5em'
        },
        {
          text: 'Unidade',
          align: 'center',
          value: 'unidadeMedida',
          width: '5em'
        },
        {
          text: 'Qtde.',
          align: 'start',
          value: 'quantidade',
          width: '5em'
        },
        {
          text: 'Unit.',
          align: 'start',
          value: 'valorUnit',
          width: '5em'
        },
        {
          text: 'Total',
          align: 'start',
          value: 'total',
          width: '5em'
        },
        {
          text: 'Ações',
          align: 'start',
          value: 'acoes',
          width: '1em'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('Pedido', ['getPedido']),

    getProdutosPedido () {
      return this.getPedido.produtos || []
    }
  },

  methods: {
    removerProduto (payload) {
      return this.$store.dispatch('Pedido/removerProduto', payload)
    },

    moneyFormatter,

    getPrecoPadrao (item) {
      // faz o calculo da quantidade de produtos com base na unidade de medida
      const valor_total_unidade_medida = calcular_preco_unidade_medida({
        lista_unidade_medida: item.produto.unidadesMedida,
        preco_unit: +item.produto.precosVenda?.[0]?.precoUnit,
        unidadeMedida: item.unidadeMedida,
        unidadeMedidaPadrao: item.produto.unidadeMedida
      })

      return valor_total_unidade_medida
    },

    getValorTotalDesconto (item) {
      const preco_desconto = this.getPrecoPadrao(item) - Number(item.valorUnit)
      return preco_desconto > 0 ? preco_desconto : 0
    },

    buildProdutoImage (produto) {
      const imgs = imageService.getProdutoImages(produto)[0]
      return {
        src: imgs.img,
        'lazy-src': imgs.thumb
      }
    },

    onEditarProdutoClick (pedProd) {
      if (!pedProd.produto) return
      this.isLoading = true

      ProdutosService.buscarProdutosPorId([pedProd.produto.id])
        .then(resp => {
          const dlg = this.$refs.dlgProdDet
          dlg.show(resp.data[0])
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    onExcluirProdutoClick (pedProd) {
      const dlg = this.$refs.dlgQuestion
      dlg.show(pedProd.produto.id, {
        title: 'Remoção de Produto',
        message: 'Deseja remover o produto do carrinho?',
        aprovarLabel: 'Ok'
      })
    },

    async handleRemoveProduto (payload) {
      this.isLoading = true
      try {
        if (payload === '-1') {
          this.$store.dispatch('Pedido/removerTodosProdutos')
          this.isLoading = false
          Vue.nextTick(() => {
            window.scrollTo(0, 0)
            this.$router.push('/')
          })
        } else {
          await this.removerProduto(payload)
          this.isLoading = false
          if (!this.getPedido.produtos?.length) {
            Vue.nextTick(() => {
              window.scrollTo(0, 0)
              this.$router.push('/')
            })
          }
        }
      } catch (error) {
        console.error('Erro ao remover produto:', error)
        this.isLoading = false
      }
    },

    onLimparCarrinhoClick () {
      const dlg = this.$refs.dlgQuestion
      dlg.show('-1', {
        title: 'Limpar Carrinho',
        message: 'Deseja remover todos os produtos do carrinho?',
        aprovarLabel: 'Ok'
      })
    },

    onContinuarComprandoClick () {
      window.scrollTo(0, 0)
      this.$router.push('/produtos')
    },

    getCupomAplicado (item) {
      if (!item.cupom_desconto_id) return null
      return this.getPedido.cupomDesconto?.find(
        c => c.id === item.cupom_desconto_id
      )
    }
  }
}
</script>

<style lang="scss"></style>
